import { state } from "../../../../../scripts/blueprints/module/store/state";
import { createUserlist } from "../../models/userlist.model";


export const sharingSettingsGetters = {
  sharingSettingsData: (state) => state.sharingSettingsData,
  rssData:(state)=>state.rssData
}
